export interface Rules {
  minutesBefore: number;
  refundPercentege: number;
  label?: string;
}

export interface CancellationPolicyModel {
  _id: string;
  rules: Rules[];
  defaultRefundPercentege: number;
  defaultLabel?: string;
  name: string;
}
